// src/store/slices/featureFlagsSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  billing: false, // default
};

const featureFlagsSlice = createSlice({
  name: "featureFlags",
  initialState,
  reducers: {
    setFeatureFlags: (state, action) => {
      return { ...state, ...action.payload };
    },
  },
});

export const { setFeatureFlags } = featureFlagsSlice.actions;
export default featureFlagsSlice.reducer;
